<template>
  <div class="Share">
    <h4 class="Share__title">{{ copy }}</h4>
    <div class="Share__icons">
      <a
        :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`"
        target="_blank"
        title="Share on Facebook"
      >
        <img alt="Share on Facebook" src="../assets/facebook.svg" />
      </a>
      <a :href="`${tweetUrl}`" target="_blank" title="Share on Twitter">
        <img alt="Share on Twitter" src="../assets/twitter.svg" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ShareSocialMedia',
  props: {
    copy: {
      type: String
    },
    end: {
      type: Boolean
    }
  },
  data() {
    return {
      urlRating: 'https://www.theglenlivet.com/discoverspectra?rating=',
      url: 'https://www.theglenlivet.com/discoverspectra'
    }
  },
  computed: {
    ...mapState(['level']),
    shareUrl() {
      let shareUrl
      if (this.end) {
        shareUrl = this.url
      } else {
        const level = this.level.replace(/\s/g, '')
        shareUrl = `${this.urlRating}${level}`
      }
      return shareUrl
    },
    tweetUrl() {
      let tweetUrl
      if (this.end) {
        tweetUrl = `https://twitter.com/intent/tweet?url=${this.url}&text=I%20challenged%20my%20senses%20with%20The%20Glenlivet%20Spectra.%20Start%20your%20journey%20and%20discover%20a%20spectrum%20of%20flavours%20%40theglenlivet.`
      } else {
        tweetUrl = `https://twitter.com/intent/tweet?url=${this.shareUrl}&text=I%20challenged%20my%20senses%20with%20%40theglenlivet%20and%20proved%20myself%20a%20${this.level}.%20Enter%20the%20sensorial%20world%20of%20The%20Glenlivet%20Spectra%20and%20find%20out%20your%20score.`
      }
      return tweetUrl
    }
  }
}
</script>

<style lang="scss">
@import '../scss/variables.scss';
@import '../scss/mixins.scss';
@import '../scss/transitions.scss';
@import '../scss/flavour.scss';
.Share {
  min-width: 135px;

  &__title {
    color: $white;
    font-family: $primary-font;
    text-transform: uppercase;
    letter-spacing: 1.29px;
    font-size: 12px;
    margin-bottom: 15px;
  }

  &__icons {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
